import { render } from "./CreateAccountForm.vue?vue&type=template&id=66b66690"
import script from "./CreateAccountForm.vue?vue&type=script&lang=js"
export * from "./CreateAccountForm.vue?vue&type=script&lang=js"

import "./CreateAccountForm.vue?vue&type=style&index=0&id=66b66690&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__